import React, { memo } from 'react'
import { Button } from 'react-bootstrap'

const SchedulingHeader = memo(({ title, onBack }) => {
  if (!onBack) return null

  return (
    <div className='d-flex align-items-center py-auto mb-3'>
      <Button variant='none' className='p-0 border-0 mr-3' onClick={onBack}>
        <svg
          width='20'
          height='32'
          viewBox='0 0 20 32'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M16 3L4 16'
            stroke='black'
            strokeWidth='3'
            strokeLinecap='round'
          />
          <path
            d='M16 29L4 16'
            stroke='black'
            strokeWidth='3'
            strokeLinecap='round'
          />
        </svg>
      </Button>
      <div>
        <h3 className='sa7 mb-1'>{title}</h3>
      </div>
    </div>
  )
})

SchedulingHeader.displayName = 'SchedulingHeader'

export default SchedulingHeader
